module.exports = __webpack_public_path__ + "img/预警动画-交易对.c2d68024.gif";